import { gql } from '@apollo/client';

export const UPDATE_QUESTION = gql(/*GraphQL*/ `
mutation UpdateQuestion($updateQuestionInput: UpdateQuestionInput!) {
  updateQuestion(updateQuestionInput: $updateQuestionInput) {
    explanation
    prompt
    id
    options {
      desc
      isAnswer
    }
    tag
    label
  }

}`);
